export default "__VITE_ASSET__CVRWaDKf__"